import partPersons from './_persons';
import partVehicles from './_vehicles';

import modalEstimate from './_modal.estimate';
import modalEstimateHeat from './_modal.estimate-heat';

export default {

  data() {
    return {

      id: null,

      monthlyData: {

        id: null,
        bid: null,
        closed: false,

        living_hs_consumption: 0,
        living_hs_consumption_2: 0,
        living_hs_consumption_3: 0,
        living_pt_consumption: 0,
        living_pt_pg_power_1: 0,
        living_pt_pg_consumption_1: 0,
        living_pt_pg_power_2: 0,
        living_pt_pg_consumption_2: 0,

        food_eating_habits_regional: 'haelfte',
        food_eating_habits_seasonal: 'haelfte',
        food_eating_habits_frozenfoods: 'haelfte',
        food_eating_habits_oeko: 'teilweise',

        living_hs_consumption_type: 'detail',
        living_hs_estimate_consumption_json: null,

        living_pt_consumption_type: 'detail',
        living_pt_estimate_consumption_code: '',

        persons: [],
        vehicles: [],

      },

      baseData: null,

      monthlyDataChanged: false,

      currentStep: 0,

      options: {},

      getMonthlyDataRequest: null,
      getMonthlyDataRequestError: null,

      onSaveMonthlyDataRequest: null,
      onSaveMonthlyDataError: null,
      onSaveMonthlyDataSuccess: null,

    }
  },

  components: { partPersons, partVehicles, modalEstimate, modalEstimateHeat },

  mounted() {
    this.id = this.$route.params.id;
    console.log('MOUNTED with id: ' + this.id);
    this.getMonthlyData();
    this.options = this.co2Service.getOptions();
  },

  methods: {

    getOptionText(option, value) {
      return this.co2Service.getOptionText(option, value);
    },

    getOptionType(option, value) {
      return this.co2Service.getOptionType(option, value);
    },

    onEstimateCallback(itemsName, code) {
      this.monthlyData[itemsName + '_code'] = code;
    },

    onEstimateHeatCallback(jsonString) {
      this.monthlyData.living_hs_estimate_consumption_json = jsonString;
    },

    onSaveMonthlyData(closeSubmit) {

      let dataObj = {...this.monthlyData};
      dataObj.closed = closeSubmit ? 1 : 0;

      this.onSaveMonthlyDataSuccess = false;
      this.onSaveMonthlyDataError = null;
      this.onSaveMonthlyDataRequest = this.apiService.put('co2rechner/monthly/' + this.id, dataObj)
        .then(result => {

          if (result.error) {
            this.onSaveMonthlyDataError = result.error;
          } else {
            this.onSaveMonthlyDataSuccess = true;
            if (closeSubmit) {
              this.monthlyData.closed = true;
              this.$router.push({ name: 'user.co2rechner.monthly' });
            }
          }

          this.onSaveMonthlyDataRequest = null;
        });

      this.monthlyDataChanged = false;
    },

    getMonthlyData() {

      this.getMonthlyDataRequestError = null;

      this.getMonthlyDataRequest = this.apiService.get('co2rechner/monthly/' + this.id)
        .then(result => {

          if (result.error) {
            this.getMonthlyDataRequestError = result.error;
            console.error('getMonthlyDataRequestError', result.details);
          } else if ((result.data && result.data.length !== 0)) {
            this.monthlyData = result.data;
            this.monthlyData.closed = Number(this.monthlyData.closed) === 1;
          }

          let bid = null;
          if (this.monthlyData.closed) { // nur spezifische Basedata-ID nehmen, wenn abgeschlossen, sonst immer die letzte!
            bid = this.monthlyData.bid ? this.monthlyData.bid : null;
          }

          this.getMonthlyDataRequest = this.apiService.get('co2rechner/basedata' + (bid ? ('/' + bid) : '/last'))
            .then(result => {

              if (result.error) {
                this.getMonthlyDataRequestError = result.error;
              } else {
                this.baseData = result.data;
                this.preparePersonsVehicles();
                console.log('baseData', this.baseData);
                if (this.baseData) {
                  this.monthlyData.bid = this.baseData.id;

                  if (this.monthlyData.persons.length !== this.baseData.persons.length) {
                    // Basedata haben sich verändert!
                    console.warn('Basedata haben sich scheinbar verändert! (persons)');
                    this.monthlyData.persons = [];
                  }

                  if (this.monthlyData.vehicles.length !== this.baseData.vehicles.length) {
                    // Basedata haben sich verändert!
                    console.warn('Basedata haben sich scheinbar verändert! (vehicles)');
                    this.monthlyData.vehicles = [];
                  }

                  this.$nextTick(function () {
                    this.monthlyDataChanged = false
                  })
                } else {
                  // Basisdaten noch nicht gestzt -> Infotext
                  this.noBasedata = true;

                }
                this.getMonthlyDataRequest = null;
              }
            });

        });

      //
      // this.getMonthlyDataRequestError = null;
      //
      // this.getMonthlyDataRequest = this.apiService.get('co2rechner/monthly/' + this.id)
      //   .then(result => {
      //
      //     if (result.error) {
      //       this.getMonthlyDataRequestError = result.error;
      //       console.log('this.getMonthlyDataRequestError', result.details);
      //     } else if ((result.data && result.data.length !== 0)) {
      //       this.monthlyData = result.data;
      //       console.log('this.monthlyData', this.monthlyData.persons.length);
      //       this.monthlyData.closed = Number(this.monthlyData.closed) === 1;
      //     }
      //
      //     let bid = this.monthlyData.bid ? this.monthlyData.bid : null;
      //
      //     this.getMonthlyDataRequest = this.apiService.get('co2rechner/basedata' + (bid ? ('/' + bid) : '/last'))
      //       .then(result => {
      //
      //         if (result.error) {
      //           this.getMonthlyDataRequestError = result.error;
      //         } else {
      //           this.baseData = result.data;
      //           this.preparePersonsVehicles();
      //           console.log('baseData', this.baseData);
      //           if (this.baseData) {
      //             this.monthlyData.bid = this.baseData.id;
      //           } else {
      //             // Basisdaten noch nicht gestzt -> Infotext
      //             this.noBasedata = true;
      //           }
      //           this.getMonthlyDataRequest = null;
      //         }
      //       });
      //
      //   });

    },

    preparePersonsVehicles() {
      this.baseData.persons.map(person => {
        this.$set(person, 'displayName', (person.name ? person.name : 'Person ' + person.position));
      });
      this.baseData.vehicles.map(vehicle => {
        this.$set(vehicle, 'displayName', (vehicle.name ? vehicle.name : 'Fahrzeug ' + vehicle.position));
      });
    }
  }

}
